import { gql } from '@apollo/client';

export const GET_FEEDBACK_OPTIONS = gql`
    query GetFeedbackOptions($input: GetFeedbackOptionsInput!) {
        getFeedbackOptions(input: $input) {
            id
            category {
                id
                title
                displayOrder
            }
            displayOrderWithInCategory
            title
            value
            hasCustomValue
            enabled
            targetType
        }
    }
`;
